import { Send } from "lucide-react";

const CheckpointSubmit = ({ value, loading, onSubmit}) => (
  <button
    className="flex items-center md:gap-1 md:px-2 md:py-1 px-1 py-[3px] bg-blue-100 text-blue-700 rounded-lg border border-blue-300 hover:bg-blue-200 disabled:hover:bg-blue-100 disabled:opacity-50 text-xs md:text-sm"
    disabled={value === "" || value === false || loading}
    onClick={onSubmit}
  >
    <Send className="w-3 h-3 md:w-4 md-h-4" />
    {loading ? "Loading..." : "Submit"}
  </button>
);

export default CheckpointSubmit;
